import { useState, useEffect } from 'react';

/**
 * Delays updating the returned value until `delay` ms have passed
 * without the input value changing. Prevents firing API calls on
 * every keystroke in search inputs.
 *
 * @param {*} value - The value to debounce
 * @param {number} delay - Debounce delay in milliseconds (default 350ms)
 * @returns The debounced value
 */
export function useDebounce(value, delay = 350) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
